import React,{Component} from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import classnames from 'classnames';
import { renderPass, renderField, renderSelectField, renderToggle, required, minValue, renderTextArea, number, positive_float } from "../../../utils/formValidations.js";
import { connect } from "react-redux";
import { getZones, updateZone } from "../../../actions/actionZones";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";
import {getLicenses} from "../../../actions/actionSystemInfo";
import {withTranslation} from "react-i18next";
// New form related items
import { Groups, Group, FormField, Button, FormFooter } from "../../../components/Form"

const minValue50 = minValue(50);

class ZoneFormTemplate extends Component  {
    constructor(props){
        super(props);
        this.state  = {
            currentZone: null,
            auto_scaling: false,
            activeTab: 0
        };
        this.submitZone= this.submitZone.bind(this);
        this.initializeForm = this.initializeForm.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    toggle(tab){
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }


    submitZone(userData){
        if (this.props.fromUpdate){
            userData.zone_id = this.props.zoneId;
            this.props.updateZone(userData).
                then(() => this.handleUpdateSuccess()).
                catch(() => this.handleUpdateError());
        }
        else {
            this.props.createZone(userData).
                then(() => this.handleCreateSuccess()).
                catch(() => this.handleCreateError());
        }
    }



    initializeForm(res){
        let currentZone = res.response.zones.find(zone => zone.zone_id === this.props.zoneId);
        this.setState({currentZone: currentZone});
        this.props.initialize({
            allow_origin_domain: currentZone.allow_origin_domain,
            upstream_auth_address: currentZone.upstream_auth_address,
            proxy_connections: currentZone.proxy_connections,
            proxy_rdp_client_connections: currentZone.proxy_rdp_client_connections,
            proxy_hostname: currentZone.proxy_hostname,
            proxy_path: currentZone.proxy_path,
            proxy_port: currentZone.proxy_port,
            proxy_rdp_hostname: currentZone.proxy_rdp_hostname,
            proxy_rdp_port: currentZone.proxy_rdp_port,
            zone_name: currentZone.zone_name,
            load_strategy: currentZone.load_strategy,
            prioritize_static_agents: currentZone.prioritize_static_agents,
            search_alternate_zones: currentZone.search_alternate_zones,
            zone_id: currentZone.zone_id,
            verify_rdp_client_ip: currentZone.verify_rdp_client_ip,
            enable_rdp_https_gw: currentZone.enable_rdp_https_gw,
            enable_rdp_https_gw_dlp: currentZone.enable_rdp_https_gw_dlp
        });
    }


    componentDidMount(){
        if (this.props.fromUpdate){
            this.props.getZones().then((res) => this.initializeForm(res));
        }
        this.props.getLicenses()
            .then(() => {
                const {licenses} = this.props;
                for (let i in licenses) {
                    if (licenses[i].is_verified == true && licenses[i].features && licenses[i].features.auto_scaling === true) {
                        this.setState({auto_scaling: true})
                    }
                }
            });

    }

    render(){
        const {handleSubmit, has_proxy, has_rdp_proxy, has_rdp_https_proxy, t} = this.props;
        const {currentZone} =  this.state;
        const proxy_checked = currentZone && currentZone.proxy_connections;
        const rdp_proxy_checked = currentZone && currentZone.proxy_rdp_client_connections;
        const prioritize_static_agents_checked = currentZone && currentZone.prioritize_static_agents;
        const search_alternate_zones_checked = currentZone && currentZone.search_alternate_zones;
        const verify_rdp_client_ip_checked = currentZone && currentZone.verify_rdp_client_ip;
        const enable_rdp_https_gw_checked = currentZone && currentZone.enable_rdp_https_gw;
        const enable_rdp_https_gw_dlp_checked = currentZone && currentZone.enable_rdp_https_gw_dlp;


        return (
            <Groups onSubmit={handleSubmit(this.props.save)} section={this.props.section}>
                <Group title="basic-details" description="basic-details-description">

                                <Field type="text"
                                    name="zone_name"
                                    id="zone_name"
                                    component={renderField} 
                                    validate={required} required
                                /> 
                                <Field type="text"
                                       name="allow_origin_domain"
                                       id="allow_origin_domain"
                                       component={renderField}
                                       help="kb-11-1"
                                       validate={required} required
                                />
                                <Field type="text"
                                       name="upstream_auth_address"
                                       id="upstream_auth_address"
                                       component={renderField}
                                       help="kb-11-2"
                                       validate={required} required
                                />
                                <Field type="text"
                                       name="load_strategy"
                                       id="load_strategy"
                                       component={renderSelectField}
                                       help="kb-11-3"
                                       clearable={false}>
                                    <option value="least_load">{t('zones.least-load')}</option>
                                    <option value="most_load">{t('zones.most-load')}</option>
                                    <option value="least_kasms">{t('zones.least-sessions')}</option>
                                    <option value="most_kasms">{t('zones.most-sessions')}</option>
                                </Field>
                                <Field type="checkbox"
                                       name="search_alternate_zones"
                                       id="search_alternate_zones"
                                       help="kb-11-4"
                                       checked = {search_alternate_zones_checked}
                                       component={renderToggle}
                                />
                                <Field type="checkbox"
                                        name="prioritize_static_agents"
                                        id="prioritize_static_agents"
                                        checked = {prioritize_static_agents_checked}
                                        help="kb-11-5"
                                        component={renderToggle}
                                />
                </Group>
                <Group title="proxy-details" description="proxy-details-description">
                    <Field type="checkbox"
                            name="proxy_connections"
                            id="proxy_connections"
                            help="kb-11-6"
                            checked = {proxy_checked}
                            component={renderToggle}
                    />       
                    { has_proxy &&
                    <React.Fragment>
                                        <Field type="text"
                                            name="proxy_hostname"
                                            id="proxy_hostname"
                                            help="kb-11-7"
                                            component={renderField}
                                            validate={required} required
                                        />
                                        <Field type="text"
                                            name="proxy_path"
                                            id="proxy_path"
                                            help="kb-11-8"
                                            component={renderField}
                                            validate={required} required
                                        />
                                        <Field
                                            type="number"
                                            name="proxy_port"
                                            id="proxy_port"
                                            help="kb-11-9"
                                            component={renderField}
                                            validate={number} required
                                        />
                    </React.Fragment>
                    }

                    { has_rdp_https_proxy &&
                        <React.Fragment>
                        <Field type="checkbox"
                                name="proxy_rdp_client_connections"
                                id="proxy_rdp_client_connections"
                                help="kb-11-10"
                                checked={rdp_proxy_checked}
                                component={renderToggle}
                        />
                        { has_rdp_proxy &&
                        <React.Fragment>
                                            <Field type="text"
                                                name="proxy_rdp_hostname"
                                                id="proxy_rdp_hostname"
                                                help="kb-11-13"
                                                component={renderField}
                                                validate={required} required
                                            />
                                            <Field
                                                type="number"
                                                name="proxy_rdp_port"
                                                id="proxy_rdp_port"
                                                help="kb-11-14"
                                                component={renderField}
                                                validate={number} required
                                            />
                        </React.Fragment>
                        }
                    </React.Fragment>
                    }

                </Group>
                <Group title="rdp-gw-details" description="rdp-gw-details-description">
                    <Field type="checkbox"
                            name="verify_rdp_client_ip"
                            id="verify_rdp_client_ip"
                            help="kb-11-11"
                            checked={verify_rdp_client_ip_checked}
                            component={renderToggle}
                    />

                    <Field type="checkbox"
                            name="enable_rdp_https_gw"
                            id="enable_rdp_https_gw"
                            help="kb-11-12"
                            checked={enable_rdp_https_gw_checked}
                            component={renderToggle}
                    />

                    <Field type="checkbox"
                            name="enable_rdp_https_gw_dlp"
                            id="enable_rdp_https_gw_dlp"
                            help="kb-11-15"
                            checked={enable_rdp_https_gw_dlp_checked}
                            component={renderToggle}
                    />
                </Group>
                <FormFooter cancel={() => this.props.history.push("/zones")} />
            </Groups>
        );
    }
}

ZoneFormTemplate.propTypes = {
    updateZone: Proptypes.func.isRequired,
    getZones: Proptypes.func.isRequired,
    updatErrorWarning: Proptypes.func,
    history: Proptypes.object.isRequired,
    updateZoneError: Proptypes.func,
    createZoneError: Proptypes.func,
    fromUpdate: Proptypes.bool,
    createZone: Proptypes.func,
    errorCreateMessage: Proptypes.string,
    zones: Proptypes.array,
    getZoneLoading: Proptypes.bool,
    errorUpdateMessage: Proptypes.string,
    initialize: Proptypes.func,
    handleSubmit: Proptypes.func,
    licenses: Proptypes.array,
    zoneId: Proptypes.string
};


ZoneFormTemplate = reduxForm({ // eslint-disable-line
    form: "ZoneFormTemplate" // a unique identifier for this form
})(ZoneFormTemplate); // eslint-disable-line

const selector = formValueSelector('ZoneFormTemplate');

ZoneFormTemplate = connect(  // eslint-disable-line
    state => {
        const has_proxy = selector(state, 'proxy_connections');
        const has_rdp_proxy = selector(state, 'proxy_rdp_client_connections');
        const has_rdp_https_proxy = selector(state, 'enable_rdp_https_gw');

        return {
            has_proxy,
            has_rdp_proxy,
            has_rdp_https_proxy,
            zones: state.zones.zones || [],
            errorCreateMessage: state.zones.errorCreateMessage || null,
            errorUpdateMessage: state.zones.errorUpdateMessage || null,
            updateZoneError: state.zones.updateZoneError || null,
            getZoneLoading: state.zones.getZoneLoading || false,
            createZoneError: state.zones.createZoneError || null,
            initialValues: {
                search_alternate_zones: true,
                prioritize_static_agents: true,
                proxy_connections: true,
                proxy_rdp_client_connections: true,
                proxy_hostname: '$request_host$',
                proxy_path: 'desktop',
                proxy_port: 0,
            },
            licenses: state.system_info.licenses
        }
    },
    dispatch => 
        ({
            updateZone: (data) => dispatch(updateZone(data)),
            getLicenses: () => dispatch(getLicenses()),
            getZones: () => dispatch(getZones())
        })) 
(ZoneFormTemplate);  //eslint-disable-line
const ZoneFormTemplateTranslated = withTranslation('common')(ZoneFormTemplate)
export default withRouter(ZoneFormTemplateTranslated);